import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { Select } from 'foundations-components/transitional/components/Select';
import { AI_CHATBOT, OWNER } from '../constants/RoutingTypes';
import { getFallbackRoutingTypeOptions } from '../constants/RoutingRulesSelectOptions';
import { getFallbackType, getRotationMethod, getType } from '../operators/routingRulesGetters';
import { setFallback } from '../operators/routingRulesSetters';
import { buildRoutingRulesFromType } from '../utils/buildRoutingRulesFromType';
import { getUsersSeatsUrl } from '../../urls/getUsersSeatsUrl';
import { RoutingMethodTooltip } from './RoutingMethodTooltip';
import RuleBox from './RuleBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getFallbackTitle = routingRules => {
  const type = getType(routingRules);
  switch (type) {
    case AI_CHATBOT:
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "routing-ui.routingRules.fallback.aiChatbotLabel"
      });
    case OWNER:
    default:
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "routing-ui.routingRules.fallback.label"
      });
  }
};
const getFallbackTooltip = (routingRules, isUngatedForHelpDeskRoutingScopeFiltering) => {
  const type = getType(routingRules);
  switch (type) {
    case AI_CHATBOT:
      return /*#__PURE__*/_jsx(Text, {
        as: "small",
        color: "text-core-on-fill-default",
        marginBlockEnd: "0",
        children: /*#__PURE__*/_jsx(RoutingMethodTooltip, {
          routingRules: routingRules
        })
      });
    case OWNER:
    default:
      return isUngatedForHelpDeskRoutingScopeFiltering ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "routing-ui.routingRules.fallback.tooltip.onlyAssignsWhenNoServiceSeat_jsx",
        elements: {
          Link
        },
        options: {
          external: true,
          href: getUsersSeatsUrl()
        }
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "routing-ui.routingRules.fallback.tooltip.onlyAssignsWhen"
          })
        }), /*#__PURE__*/_jsx(Text, {
          color: "text-core-on-fill-default",
          marginBlockEnd: "0",
          children: /*#__PURE__*/_jsx(RoutingMethodTooltip, {
            routingRules: routingRules
          })
        })]
      });
  }
};
const FallbackRow = ({
  disabled,
  routingRules,
  onRuleUpdate,
  FormControl,
  isUngatedForHelpDeskRoutingScopeFiltering
}) => {
  const fallbackType = getFallbackType(routingRules);
  const rotationMethod = getRotationMethod(routingRules) || undefined;
  const onFallbackTypeChange = evt => {
    onRuleUpdate(setFallback(buildRoutingRulesFromType(evt.target.value, {
      rotationMethod
    }), routingRules));
  };
  return /*#__PURE__*/_jsx(RuleBox, {
    FormControl: FormControl,
    label: getFallbackTitle(routingRules),
    required: true,
    tooltip: getFallbackTooltip(routingRules, isUngatedForHelpDeskRoutingScopeFiltering),
    tooltipProps: {
      maxWidth: 287
    },
    children: /*#__PURE__*/_jsx(Select, {
      defaultOpen: false,
      disabled: disabled,
      options: getFallbackRoutingTypeOptions(),
      searchable: false,
      value: fallbackType,
      onChange: onFallbackTypeChange
    })
  });
};
FallbackRow.displayName = 'FallbackRow';
export default FallbackRow;